import * as React from "react";
import { appStore, BreadcrumbItem } from "src/appStore";

import * as styles from "./PageLayout.module.less";

export type PropsPageLayout = {
  children?: React.ReactNode;
  title: BreadcrumbItem[] | React.ReactNode;
};

export const PageLayout: React.FC<PropsPageLayout> = ({
  title,
  children,
}: PropsPageLayout) => {
  /**
   * Заголовок страницы выводится в области header
   * было решено передавать его в PageLayout и устанавливать тут
   */
  React.useEffect(() => {
    appStore.setPageTitle(title);
    return () => {
      appStore.setPageTitle("");
    };
  }, [title]);

  return (
    <div className={styles.pageLayout}>
      <div className={styles.pageContent}>{children}</div>
    </div>
  );
};
